export { Cfooter, CfooterContent } from './Cfooter';
export type { CfooterContentProps, CfooterProps } from './Cfooter';
